import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {LibraryDialogController} from '../LibraryDialog.controller';

@observer
export class LibraryDialogHeader extends TechseeBaseComponent<{ctrl: LibraryDialogController}> {
    renderInternal(): JSX.Element {
        const {ctrl} = this.props;

        // Convert observable array to regular array for rendering
        const breadcrumbs = [...ctrl.libDirectories.slice()];

        return (
            <ol className='breadcrumb pull-left' key={breadcrumbs.join('/')}>
                {breadcrumbs.map((dir, index) => (
                    <li key={`breadcrumb-${dir}-${index}`}>
                        <a
                            href='#'
                            onClick={(e) => {
                                e.preventDefault();
                                ctrl.loadDirectory(dir);
                            }}>
                            {dir}
                        </a>
                    </li>
                ))}
            </ol>
        );
    }
}
